import React from 'react';

const Loader = ({
  isLoading,
  message = 'Loading...',
  color = '#ff6b35',
}) => {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(255,255,255,0.7)',
        backdropFilter: 'blur(6px) brightness(0.95)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        transition: 'all 0.3s',
      }}
    >
      <div
        style={{
          background: 'rgba(255,255,255,0.95)',
          padding: '24px 32px',
          borderRadius: '14px',
          boxShadow: '0 8px 36px rgba(30, 60, 90, 0.14)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          minWidth: '220px',
          border: `2px solid ${color}`,  // orange border
        }}
      >
        {/* Modern CSS Loader */}
        <div
          style={{
            display: 'flex',
            gap: '8px',
          }}
        >
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                backgroundColor: color,
                animation: `loaderBounce 1.4s -${i * 0.3}s infinite ease-in-out`,
              }}
            />
          ))}
        </div>

        <span
          style={{
            color: '#333',
            fontSize: '20px',      // increased font size
            fontWeight: 600,
            fontStyle: 'italic',
            letterSpacing: '0.1em',
            opacity: 0.84,
            textAlign: 'center',
          }}
        >
          {message}
        </span>
      </div>
      <style>
        {`
          @keyframes loaderBounce {
            0%, 80%, 100% {
              transform: scale(0);
              opacity: 0.6;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
